export interface ForemanCustomerEquipment {
  foremanCustomerEquipmentID: string;
  foremanParentFacilityID?: string | null;
  foremanJobID?: string | null;
  unitNumber: string;
  make: string;
  model: string;
  serialNumber: string;
  modifiedDate?: Date;
}
